export default __webpack_public_path__ + "static/media/01exigo.375ce31d.jpg";